import type { Student } from "../providers/studentsProvider";
import { Dialog, DialogTitle } from "@mui/material";
import type { DialogProps } from "../misc/DialogProps";
import { StudentAdministrativeOnboardingForm } from "../details/student/StudentAdministrativeOnboardingForm";
import { StudentAdministrativeOnboardingForChangersForm } from "../details/student/StudentAdministrativeOnboardingForChangersForm";
import { DialogCloseButton } from "../misc/DialogCloseButton";

export function LicenseApplicationDialog({ student, ...dialogProps }: { student: Student } & DialogProps) {
  const { administrativeOnboardingState, administrativeOnboardingForChangersState } = student;

  let title: string;
  if (administrativeOnboardingState) {
    title = `Führerscheinantrag von ${student.name}`;
  } else if (administrativeOnboardingForChangersState) {
    title = `Fahrschulwechsel von ${student.name}`;
  } else {
    return null;
  }

  const onSaved = () => {
    showSuccessToast("Änderungen erfolgreich gespeichert.");
    dialogProps.onClose();
  };

  return (
    <Dialog {...dialogProps}>
      <DialogTitle>{title}</DialogTitle>
      <DialogCloseButton onClick={dialogProps.onClose} />
      {administrativeOnboardingState && <StudentAdministrativeOnboardingForm onSaved={onSaved} />}
      {administrativeOnboardingForChangersState && <StudentAdministrativeOnboardingForChangersForm onSave={onSaved} />}
    </Dialog>
  );
}
